import { render, staticRenderFns } from "./PromoCreate.vue?vue&type=template&id=98408b94&scoped=true"
import script from "./PromoCreate.vue?vue&type=script&lang=js"
export * from "./PromoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98408b94",
  null
  
)

export default component.exports